export const formatAsUTC = (date) => {
  const d = new Date(date);
  return `${d.getUTCFullYear()}-${(d.getUTCMonth() + 1)
    .toString()
    .padStart(2, "0")}-${d.getUTCDate().toString().padStart(2, "0")}`;
};

export const formatDate = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${(d.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
};
export const formatDisplayDate = (date) => {
  const d = new Date(date);
  return `${(d.getMonth() + 1).toString().padStart(2, "0")}-${d
    .getDate()
    .toString()
    .padStart(2, "0")}-${d.getFullYear()}`;
};
export const validatePassword = (password) => {
  let err_arr = [];
  if (password.length < 10) {
    err_arr.push("Password must be at least 10 characters long.");
  }
  if (!/[A-Z]/.test(password)) {
    err_arr.push(
      "Password must contain at least one uppercase character.[A-Z]"
    );
  }
  if (!/[a-z]/.test(password)) {
    err_arr.push(
      "Password must contain at least one lowercase character.[a-z]"
    );
  }
  if (!/\d/.test(password)) {
    err_arr.push("Password must contain at least one number.");
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    err_arr.push(
      "Password must contain at least one special character (e.g., !, @, #, $)."
    );
  }
  if (err_arr.length > 0) {
    return err_arr;
  }
  return [];
};

export const validatePhoneNumber = (phoneNumber) => {
  const regex = /^\+\d{1,4}[-\s]\d{10}$/;
  return regex.test(phoneNumber);
};

export function formatLabel(label) {
  if (label) {
    return label
      .split("_")
      .filter((word) => word.toLowerCase() !== "score")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    return label;
  }
}
